import {Component, Input, OnInit} from '@angular/core';
import {FactoryService} from "../../services/factory.service";
import {UI_TEXTS} from "../../enums/e-texts";
import {VALUE_TYPE, GENERATOR_TYPES_LIST, GENERATOR_TYPES} from "../../enums/enums";
import {isUndefined} from "util";
import {JP} from "../../helpers/jp";

@Component({
  selector: 'nv-generator',
  templateUrl: './nv-generator.component.html',
  styles: []
})
export class NvGeneratorComponent implements OnInit {

  @Input() generator:any;
  @Input() title:string;
  UI_TEXTS = UI_TEXTS;
  VALUE_TYPE = VALUE_TYPE;
  GENERATOR_TYPES_LIST = GENERATOR_TYPES_LIST;
  GENERATOR_TYPES = GENERATOR_TYPES;

  constructor(private factoryService:FactoryService) { }

  ngOnInit() {
  }

  addCategoriesToSetClicked(setItem: any): void {
    this.factoryService.addCategoriesToSetOfGarbageGenerator(setItem);
  }

  addSetClicked(): void {
    this.factoryService.addSetToGarbageGenerator(this.generator);
  }

  onTypeSelected() {
    if (this.generator.type != this.GENERATOR_TYPES.CHEST_GENERATOR)
    {
      JP.remove(this.generator, "/generatorSources");
    }
  }

  get contentVisible(): boolean {
    if (isUndefined(this.generator.admin))
    {
      this.generator.admin = {};
    }
    let v = this.generator.admin['hidden'];
    return typeof v === "undefined" || v === true;
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-generator/nv-generator.component.ts